import { Template } from "../../Components/Template/template"
import { AlertType, ConfigNFe, classBt, classDivBackground, classDivBody, classInput, classInputDark, classbtAzul, classbtVerde } from "../../Utils/Types"
import { ConfigService } from "./ConfigService"
import { MouseEvent, useEffect, useState } from "react"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { AiOutlineSetting } from "react-icons/ai"
import { IoSave } from "react-icons/io5"

export const ConfigNFPage = () => {

    // -------------------- ATRIBUTOS FEEDBACK ------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [typeFeedback, setTypeFeedback] = useState<AlertType>("SUCCESS")
    const [feedBackMessage, setFeedBackMessage] = useState("")

    // -------------------- ATRIBUTOS INPUTS ------------------------------------------
    const [id, setId] = useState(0)
    const [passwordCert, setPasswordCert] = useState("")
    const [pathCert, setPathCert] = useState("")
    const [ambiente, setAmbiente] = useState("")
    const [csc, setCSC] = useState("")
    const [cscId, setCscId] = useState("")

    const [config, setConfig] = useState<ConfigNFe>()
    const [certFile, setCertFile] = useState<File>()


    useEffect(() => {
        if (certFile === undefined) {
            const inputFile = document.getElementById("cert_file") as HTMLInputElement
            if (inputFile) {
                inputFile.value = ""
            }
        }
    }, [certFile])

    useEffect(() => {
        getConfig()
    }, [])

    const getConfig = async () => {

        setFeedBackVisible(false)
        setLoading(true)

        try {

            const config = await ConfigService.Find()

            setId(config.data.id)
            setPasswordCert(config.data.senhaCert || "")
            setPathCert(config.data.pathCertificado || "")
            setAmbiente(config.data.ambiente || "P")
            setCSC(config.data.cscNFCe || "")
            setCscId(config.data.cscIdNFCe || "")
            setConfig(config.data)

        } catch (error) {

            setFeedBackVisible(true)
            setTypeFeedback("DANGER")
            setFeedBackMessage("Não foi possivel buscar os dados do certificado")

        } finally {
            setLoading(false)
        }
    }

    const handleChangePasswordCert = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPasswordCert(e.target.value)
    }

    const handleAddCertFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setCertFile(e.target.files[0])
        }
    }

    const handleChangeAmbiente = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAmbiente(e.target.value)
    }

    const handleChangeCsc = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCSC(e.target.value)
    }

    const handleChangeCscId = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCscId(e.target.value)
    }

    const handleSave = async () => {

        setLoading(true)
        setFeedBackVisible(false)

        try {

            let dados: ConfigNFe = {
                id: 0,
                idEmpresa: 0
            }
            dados.ambiente = ambiente === "H" ? "H" : "P"
            dados.certFile = certFile
            dados.id = id
            dados.cscNFCe = csc
            dados.cscIdNFCe = cscId
            dados.senhaCert = passwordCert

            const retAPI = await ConfigService.Save(dados)
            setCertFile(undefined)

            if (retAPI.error) {

                setFeedBackVisible(true)
                setTypeFeedback("DANGER")
                setFeedBackMessage(retAPI.msg || "")

            } else {

                setFeedBackVisible(true)
                setTypeFeedback("SUCCESS")
                setFeedBackMessage("Dados gravados com sucesso")

                setConfig(retAPI.data)
                setId(retAPI.data.id)
                setPathCert(retAPI.data.pathCertificado || "")

            }

        } catch (error) {

            setFeedBackVisible(true)
            setTypeFeedback("DANGER")
            setFeedBackMessage("Não foi possivel salvar os dados")

        } finally {
            setLoading(false)
        }
    }

    const handleCloseFeedback = () => {
        setFeedBackVisible(false)
    }

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <FeedbackMessage visible={feedBackVisible} message={feedBackMessage} type={typeFeedback} onCloseMessage={handleCloseFeedback} />

                <div role='button' id="div-body" className={classDivBody}>

                    <div className={`w-full h-auto flex flex-col md:flex-row lg:flex-row items-center rounded-md bg-white dark:bg-slate-600 border dark:border-gray-800 shadow-md shadow-slate-400 dark:shadow-slate-800 cursor-default mb-2 p-2`}>
                        <div className={`flex flex-grow-1 items-center w-full h-[50px]`}>
                            <AiOutlineSetting className={`mr-2 ml-2 text-gray-700 dark:text-white`} size="25px" />
                            <span className={`text-2xl text-gray-700 dark:text-white`}>Configuração da NF-e.</span>
                        </div>
                    </div>

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-md`}>

                        <div className={`flex justify-end h-auto p-4`}>
                            <button tabIndex={-1} className={`${classBt} ${classbtAzul} max-w-[160px]`} onClick={handleSave}>
                                {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                {loading &&

                                    <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                    </div>
                                }
                                {loading ? 'Aguarde' : 'Salvar'}
                            </button>
                        </div>

                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-800`} />

                        <div className={`w-full grid grid-cols-12 gap-4 p-4`}>

                            {/* recurso utilizado para o navegador não jogar o email do usuário nesse campo */ }
                            <input
                                type="text"
                                name="fake_autofill_field"
                                style={{ display: 'none' }}
                                autoComplete="username"
                            />

                            {/* recurso utilizado para o navegador não jogar senha do usuário nesse campo */ }
                            <input
                                type="password"
                                name="fake_autofill_field"
                                style={{ display: 'none' }}
                                autoComplete="new-password"
                            />

                            <div className={`col-span-12`}>
                                <label htmlFor="cert_file" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`}>Selecione o arquivo pfx do certificado digital</label>
                                <input id="cert_file" className={`file:h-10 file:text-white file:bg-blue-500 file:outline-none file:font-mono file:text-xs file:w-[150px] file:border-2 file:border-blue-800 file:rounded-md w-full dark:text-white`} type="file" onChange={handleAddCertFile} />
                            </div>

                            <div className={`col-span-12 sm:col-span-5 2xl:col-span-2`}>
                                <label htmlFor="file_senha" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`} >Senha do certificado digital</label>
                                <input id="file_senha" className={`${classInput} ${classInputDark} w-full h-[40px] disabled:bg-gray-100`} type="password" value={passwordCert} onChange={handleChangePasswordCert} />
                            </div>

                            <div className={`col-span-12 sm:col-span-7 2xl:col-span-4`}>
                                <label htmlFor="file_certificado_digital" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`} >Certificado digital</label>
                                <input id="file_certificado_digital" className={`${classInput} ${classInputDark} w-full h-[40px] disabled:bg-gray-100`} type="text" disabled={true} value={pathCert} />
                            </div>

                            <div className={`col-span-12 sm:col-span-5 2xl:col-span-2`}>
                                <label htmlFor="file_ambiente" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`} >Ambiente</label>
                                <select id="file_ambiente" className={`${classInput} ${classInputDark} w-full h-[40px]`} value={ambiente} onChange={handleChangeAmbiente}>
                                    <option value="H">Homologação</option>
                                    <option value="P">Produção</option>
                                </select>
                            </div>

                            <div className={`col-span-12 sm:col-span-7 2xl:col-span-2`}>
                                <label htmlFor="file_csc" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`} >CSC</label>
                                <input id="file_csc" className={`${classInput} ${classInputDark} w-full h-[40px] disabled:bg-gray-100`} type="text" value={csc} onChange={handleChangeCsc} />
                            </div>

                            <div className={`col-span-12 sm:col-span-5 2xl:col-span-2`}>
                                <label htmlFor="file_csc_id" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white`} >CSC Id</label>
                                <input id="file_csc_id" className={`${classInput} ${classInputDark} w-full h-[40px] disabled:bg-gray-100`} type="text" value={cscId} onChange={handleChangeCscId} />
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>
    )

}